import { jsxs, jsx } from "react/jsx-runtime";
import { useState } from "react";
import { AiqTriangleSection } from "./AiqTriangleSection.js";
import { AiqIndexSection } from "./AiqIndexSection.js";
const TABS = [
  { id: "pre", label: "Pre-AIQ" },
  { id: "post", label: "Post-AIQ" },
  { id: "comparison", label: "비교" }
];
function ReportTabLayout({ standardReport, advancedReport, aiqIndexReport, hasPostAiq }) {
  const [activeTab, setActiveTab] = useState(hasPostAiq ? "comparison" : "pre");
  const isTabDisabled = (tabId) => !hasPostAiq && (tabId === "post" || tabId === "comparison");
  return /* @__PURE__ */ jsxs("div", { className: "bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden", children: [
    /* @__PURE__ */ jsx("div", { className: "flex border-b border-gray-200", children: TABS.map((tab) => {
      const disabled = isTabDisabled(tab.id);
      return /* @__PURE__ */ jsx(
        "button",
        {
          onClick: () => !disabled && setActiveTab(tab.id),
          disabled,
          className: `flex-1 py-3 px-4 text-sm font-medium transition-colors ${activeTab === tab.id ? "border-b-2 border-indigo-600 text-indigo-600 bg-indigo-50/50" : disabled ? "text-gray-300 cursor-not-allowed" : "text-gray-500 hover:text-gray-700 hover:bg-gray-50"}`,
          children: tab.label
        },
        tab.id
      );
    }) }),
    /* @__PURE__ */ jsx("div", { className: "p-6", children: isTabDisabled(activeTab) ? /* @__PURE__ */ jsx("div", { className: "flex items-center justify-center py-12 text-gray-400", children: /* @__PURE__ */ jsx("p", { className: "text-sm", children: "Post-AIQ를 완료한 후 확인할 수 있습니다." }) }) : /* @__PURE__ */ jsxs("div", { className: "space-y-8", children: [
      /* @__PURE__ */ jsxs("div", { children: [
        /* @__PURE__ */ jsxs("h3", { className: "text-base font-semibold text-gray-800 mb-4 flex items-center gap-2", children: [
          /* @__PURE__ */ jsx("span", { className: "inline-block w-2 h-2 rounded-full bg-blue-500" }),
          "Standard Report",
          /* @__PURE__ */ jsx("span", { className: "text-xs font-normal text-gray-400", children: "(정답률 기반)" })
        ] }),
        /* @__PURE__ */ jsx(
          AiqTriangleSection,
          {
            report: standardReport,
            type: "standard",
            phase: activeTab
          }
        )
      ] }),
      advancedReport && /* @__PURE__ */ jsxs("div", { children: [
        /* @__PURE__ */ jsxs("h3", { className: "text-base font-semibold text-gray-800 mb-4 flex items-center gap-2", children: [
          /* @__PURE__ */ jsx("span", { className: "inline-block w-2 h-2 rounded-full bg-purple-500" }),
          "Advanced Report",
          /* @__PURE__ */ jsx("span", { className: "text-xs font-normal text-gray-400", children: "(시간 가중 점수)" })
        ] }),
        /* @__PURE__ */ jsx("p", { className: "text-xs text-gray-400 mb-3", children: "같은 문제를 맞춰도 빨리 풀수록 높은 점수를 받습니다." }),
        /* @__PURE__ */ jsx(
          AiqTriangleSection,
          {
            report: advancedReport,
            type: "advanced",
            phase: activeTab
          }
        )
      ] }),
      aiqIndexReport && /* @__PURE__ */ jsxs("div", { children: [
        /* @__PURE__ */ jsxs("h3", { className: "text-base font-semibold text-gray-800 mb-4 flex items-center gap-2", children: [
          /* @__PURE__ */ jsx("span", { className: "inline-block w-2 h-2 rounded-full bg-indigo-500" }),
          "나의 AIQ 지수",
          /* @__PURE__ */ jsx("span", { className: "text-xs font-normal text-gray-400", children: "(정규분포 변환)" })
        ] }),
        /* @__PURE__ */ jsx(AiqIndexSection, { report: aiqIndexReport, phase: activeTab })
      ] })
    ] }) })
  ] });
}
export {
  ReportTabLayout
};
//# sourceMappingURL=ReportTabLayout.js.map
